import { render } from "./AdminPanel.vue?vue&type=template&id=4ab32616&scoped=true"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"

import "./AdminPanel.vue?vue&type=style&index=0&id=4ab32616&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab32616"]])

export default __exports__